const wait = (waitTimeInMs: number) =>
  new Promise<void>(resolve => {
    setTimeout(() => {
      resolve()
    }, waitTimeInMs)
  })

export default wait
